import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ManagerService, StoreService } from 'src/app/core';
import { HttpEventType, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-proof-of-performance',
  templateUrl: './proof-of-performance.component.html',
  styleUrls: ['./proof-of-performance.component.scss']
})
export class ProofOfPerformanceComponent implements OnInit {
  @Input() challenge: any;
  @ViewChild('fileInput') fileInput: any;

  showUploadForm = false;
  fileData: any = null;
  fileName = '';
  comments = '';
  selectedFileId: any = null;
  docUploading = false;
  uploadProgress: any = null;
  docUploadSuccess = false;
  docUploadFailed = false;
  documentsList: any = {};
  dataLoaded = false;
  isCiscoAdmin = false;
  selectedRole = '';

  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  constructor(private managerService: ManagerService, private storeService: StoreService) {}

  ngOnInit() {
    this.selectedRole = localStorage.getItem('selectedRole') || '';
    this.storeService.getIsciscoAdminFlag().subscribe((data: any) => {
      if (data) { this.isCiscoAdmin = data.isCiscoAdmin === true; }
    });
    this.getDocProofsList();
  }

  getDocProofsList() {
    if (!this.challenge || !this.challenge.userChallengeId) {
      this.dataLoaded = true;
      return;
    }
    this.managerService.getProofOfDocumentsList(this.challenge.userChallengeId).subscribe((data: any) => {
      this.documentsList = data;
      this.dataLoaded = true;
    }, () => {
      this.dataLoaded = true;
    });
  }

  getDocumentList(): string[] {
    return Object.keys(this.documentsList);
  }

  getDocHistory(key: string) {
    return this.documentsList[key].slice(1);
  }

  upload() {
    const popFileInputEl = document.getElementById('popFileInput');
    if (popFileInputEl) { popFileInputEl.click(); }
  }

  getFile(eve: any) {
    this.fileData = eve.target.files[0];
    this.fileName = this.fileData.name;
    this.fileInput.nativeElement.value = '';
  }

  clearFile() {
    this.fileData = null;
    this.selectedFileId = null;
    this.comments = '';
    this.fileName = '';
  }

  submitDocument() {
    this.docUploading = true;
    this.uploadProgress = 0;
    this.docUploadSuccess = false;
    this.docUploadFailed = false;
    const formData = new FormData();
    formData.append('file-to-be-uploaded', this.fileData);
    const params = '?fileName=' + this.fileName + '&comment=' + this.comments + '&docTypeId=' + this.selectedFileId.id;
    this.managerService.acSubmitProofs(this.challenge.userChallengeId, formData, params).subscribe((data: any) => {
      if (data.type === HttpEventType.UploadProgress) {
        this.uploadProgress = Math.round((100 / data.total) * data.loaded);
      } else if (data instanceof HttpResponse) {
        this.docUploading = false;
        this.docUploadSuccess = true;
        this.showUploadForm = false;
        this.getDocProofsList();
        this.clearFile();
        setTimeout(() => { this.docUploadSuccess = false; }, 5000);
      }
    }, () => {
      this.docUploading = false;
      this.docUploadFailed = true;
    });
  }

  getLocalDate(data: any) {
    return data ? new Date(data).toLocaleDateString() : null;
  }

  setTime(date: string) {
    return new Date(new Date(date).getFullYear(), new Date(date).getMonth(), new Date(date).getDate());
  }

  formatDate(date: string) {
    const month = Number(date.substring(5, 7).replace(/^0+/, '')) - 1;
    const day = date.substring(8, 10).replace(/^0+/, '');
    const year = date.substring(0, 4);
    return `${this.months[month]} ${day}, ${year}`;
  }

  getStatus(check: any, completedBy: string, creationDate: string, startDate: string) {
    const lang = localStorage.getItem('selectedLanguage');
    let value: string;
    const createdDate = this.setTime(creationDate.split('T')[0]);
    const startOn = this.setTime(startDate.split('T')[0]);
    const completeByDate = this.setTime(completedBy.split('T')[0]);
    const currentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    const isExpired = currentDate.getTime() > completeByDate.getTime();
    const creationOn = createdDate.getTime() < startOn.getTime();
    const pending = startOn.getTime() > currentDate.getTime();
    if (check) { value = this.formatDate(check); }
    if (lang === 'Korean') {
      value = '열다';
      if (!check && isExpired) { value = '닫은'; }
      if (creationOn && pending) { value = '대기 중'; }
      if (check) { value = ''; }
    } else if (lang === 'Japanese') {
      value = '開いた';
      if (!check && isExpired) { value = '閉まっている'; }
      if (creationOn && pending) { value = '保留中'; }
      if (check) { value = ''; }
    } else {
      value = 'Open';
      if (!check && isExpired) { value = 'Closed'; }
      if (creationOn && pending) { value = 'Pending'; }
      if (check) { value = ''; }
    }
    return value;
  }
}
